import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import type { RepositorySites } from "../../domain/repositories/repository-sites";
import { type UUID } from "../../utils/uuid";
import { ListCommandButtons, type ListCommandButtonsProps } from "./list-command-buttons";
import { FormCreateSite } from "../molecules/form-create-site";
import { FormUpdateSite } from "../molecules/form-update-site";

export type ListCommandButtonsSitesProps = Omit<
    ListCommandButtonsProps<RepositorySites>,
    "list" | "createForm" | "listState"
>;

import { store } from "../../store";

@observer
export class ListCommandButtonsSites extends React.Component<ListCommandButtonsSitesProps> {
    constructor(props: ListCommandButtonsSitesProps) {
        super(props);
        makeObservable(this);
    }

    @action.bound private async deleteSites(ids: UUID[]): Promise<void> {
        await store.repositorySites.delete(...ids);
        if (this.props.onDelete) {
            this.props.onDelete(ids);
        }
    }
    public render(): JSX.Element {
        return (
            <ListCommandButtons
                updateForm={FormUpdateSite}
                createForm={FormCreateSite}
                listState={store.serviceListStates.sites}
                createButtonText={store.i18n.t("page.systemWide.site.createButton.text")}
                createDialogTitle={store.i18n.t("page.systemWide.site.createDialog.title")}
                updateDialogTitle={store.i18n.t("page.systemWide.site.updateDialog.title")}
                {...this.props}
                onDelete={this.deleteSites}
            />
        );
    }
}
